import { Component } from 'react';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from "react-router";
import { IPhysiotherapist } from '../../models/IPhysiotherapist';
import { PhysiotherapistService } from '../../services/PhysiotherapistService';
import { ClinicSectionComponent } from '../Clinic/ClinicSection';
import './PhysiotherapistView.css'
import { PhysiotherapistInfoComponent } from './PhysiotherapistInfo';
import { IDiseaseCategory } from '../../models/IDiseaseCategory';
import { FileUploadComponent } from '../../controls/FileUpload';
import { IEducation } from '../../models/IEducation';
import { ITrainingCourse } from '../../models/ITrainingCourse';
import { IDropDownItem } from '../../models/IDropDownItem';
import { ITherapy } from '../../models/ITherapy';
import { IUserFile } from '../../models/IUserFile';
import BasicSearchCriteriaComponent from '../Search/BasicSearchCriteria';
import { BreadcrumbsComponent } from '../../controls/Breadcrumbs';
import { TabsComponent } from './Tabs';
import ArrangeVisitComponent from './ArrangeVisit';
import { ClinicService } from '../../services/ClinicService';
import { IClinicListItem } from '../../models/IClinicListItem';
import { IBreadcrumbItem } from '../../models/IBreadcrumbItem';
import { IPlace } from '../../models/IPlace';
import { FavoriteService } from '../../services/FavoriteService';
import { DEFAULT_STATUS_TIMEOUT } from '../../constants/SystemConsts';
import FooterComponent from '../Layout/Footer';
import FooterStaticComponent from '../Layout/FooterStatic';
import { IAdvancedSearchItem } from '../../models/IAdvancedSearchItem';
import { MapModalComponent } from './MapModal';
import { IViewport } from '../../models/IViewport';
import { ShowStatusBar } from '../Layout/GlobalStatusBar';
import { ISearchSelectedItem } from '../../models/ISearchSelectedItem';
import { ShareButtonsComponent } from '../../controls/ShareButtons';
import { IProfileInfo } from '../../models/IProfileInfo';
import { SimplifyString } from '../../utils/String';
import { IsNullEmptyOrUndefined } from '../../utils/IsNullEmptyOrUndefined';
import Helmet from 'react-helmet';


function MapState(state) {
    return {
        SearchCriteriaPlaceInputValue: state.SearchData.PlaceInputValue,
        ProfileInfo: state.Profile
    }
}

interface IProps extends RouteComponentProps<any> {
    SearchCriteriaPlaceInputValue: IPlace,
    PhysiotherapistId?: string,
    ProfileInfo: IProfileInfo
}

interface IState extends IPhysiotherapist {
    PhysiotherapistId?: string,
    DiseaseCategories: IDiseaseCategory[],
    Therapies: ITherapy[],
    AllDiseaseCategories: IDropDownItem[],
    AllTherapies: IDropDownItem[],
    Education: IEducation[],
    TrainingCourses: ITrainingCourse[],
    Certifications: IUserFile[],
    Pictures: IUserFile[],
    Languages: string[],
    ShowUploadProfileImgComponent: boolean,
    UpdatedAboutMe?: string,
    SelectedTab: 'Addresses' | 'Experience' | 'Specializations',
    ClinicsNumber: number,
    Clinics: IClinicListItem[],
    SelectedClinic?: IClinicListItem,
    Place?: IPlace,
    ResultItems: IAdvancedSearchItem[],
    MapVisible: boolean,
    ShareVisible: boolean
}

class PhysiotherapistViewComponent extends Component<IProps, IState> {

    private basicSearchRef = React.createRef<any>();

    constructor(props) {
        super(props);

        let parsedId: string | undefined;
        let urlParamsList = this.GetUrlParamsList(this.props);
        if (urlParamsList.length > 0) {
            parsedId = urlParamsList[urlParamsList.length - 1];
        }

        this.state = {
            PhysiotherapistId: (parsedId === null || parsedId === undefined || parsedId === '') ?
                (this.props.PhysiotherapistId ? this.props.PhysiotherapistId : undefined) :
                parsedId,
            Email: undefined,
            FirstName: undefined,
            LastName: undefined,
            ProfessionNumber: undefined,
            ProfessionalTitle: undefined,
            DiseaseCategories: [],
            Therapies: [],
            AllDiseaseCategories: [],
            AllTherapies: [],
            Education: [],
            TrainingCourses: [],
            Certifications: [],
            Pictures: [],
            Languages: [],
            ShowUploadProfileImgComponent: false,
            AboutMe: undefined,
            SelectedTab: 'Addresses',
            ClinicsNumber: 0,
            Clinics: [],
            ResultItems: [],
            MapVisible: false,
            ShareVisible: false
        }

        this.OnGetDataError = this.OnGetDataError.bind(this);
        this.OnGetDataSuccess = this.OnGetDataSuccess.bind(this);
        this.OnSetProfileImgClick = this.OnSetProfileImgClick.bind(this);
        this.OnProfileImgUploaded = this.OnProfileImgUploaded.bind(this);
        this.OnDeleteProfileImgClick = this.OnDeleteProfileImgClick.bind(this);
        this.OnDeleteProfileImgSuccess = this.OnDeleteProfileImgSuccess.bind(this);
        this.OnDeleteProfileImgError = this.OnDeleteProfileImgError.bind(this);
        this.RefreshBasicInfo = this.RefreshBasicInfo.bind(this);
        this.RefreshClinicsListData = this.RefreshClinicsListData.bind(this);
        this.OnTabSelected = this.OnTabSelected.bind(this);
        this.OnGetClinicListItemsSuccess = this.OnGetClinicListItemsSuccess.bind(this);
        this.OnGetClinicListItemsError = this.OnGetClinicListItemsError.bind(this);
        this.AddToFavorite = this.AddToFavorite.bind(this);
        this.OnAddToFavoriteSuccess = this.OnAddToFavoriteSuccess.bind(this);
        this.OnAddToFavoriteError = this.OnAddToFavoriteError.bind(this);
        this.RemoveFavorite = this.RemoveFavorite.bind(this);
        this.OnRemoveFavoriteSuccess = this.OnRemoveFavoriteSuccess.bind(this);
        this.OnRemoveFavoriteError = this.OnRemoveFavoriteError.bind(this);
        this.CloseMapModal = this.CloseMapModal.bind(this);
        this.ShowClinicOnMap = this.ShowClinicOnMap.bind(this);
        this.OnFooterItemClick = this.OnFooterItemClick.bind(this);
        this.ShowShareModal = this.ShowShareModal.bind(this);
        this.HideShareModal = this.HideShareModal.bind(this);
        this.UpdateUrl = this.UpdateUrl.bind(this);
        this.OnClinicSelected = this.OnClinicSelected.bind(this);
        this.GenerateUrl = this.GenerateUrl.bind(this);

        this.RefreshBasicInfo();
    }

    public componentWillReceiveProps(nextProps: IProps) {
        let parsedId: string | undefined;
        let urlParamsList = this.GetUrlParamsList(nextProps);
        if (urlParamsList.length > 0) {
            parsedId = urlParamsList[urlParamsList.length - 1];
        }

        let nextPhysiotherapistId = (parsedId === null || parsedId === undefined || parsedId === '') ?
            (nextProps.PhysiotherapistId ? nextProps.PhysiotherapistId : undefined) :
            parsedId;
        if (this.state.PhysiotherapistId !== nextPhysiotherapistId) {
            this.setState({
                PhysiotherapistId: nextPhysiotherapistId
            });
            this.RefreshBasicInfo(nextPhysiotherapistId);
            this.RefreshClinicsListData(nextPhysiotherapistId);
        }
    }

    public render() {
        let metaTitleValue =
            ((!IsNullEmptyOrUndefined(this.state.FirstName) && !IsNullEmptyOrUndefined(this.state.LastName)) ? (this.state.FirstName + " " + this.state.LastName + " - ") : "") +
            "Znajdź Fizjoterapeutę";
        let metaDescriptionValue =
            ((!IsNullEmptyOrUndefined(this.state.FirstName) && !IsNullEmptyOrUndefined(this.state.LastName)) ?
                (this.state.FirstName + " " + this.state.LastName + " to zaufany fizjoterapeuta dla Ciebie i Twoich bliskich. Umów wizytę teraz!") :
                "");
        return (
            <>
                <Helmet>
                    <meta name="title" content={metaTitleValue} />
                    <meta name="description" content={metaDescriptionValue} />
                    {
                        IsNullEmptyOrUndefined(this.state.ProfileImgUrl) ?
                            (<meta property="og:image" content="https://znajdzfizjoterapeute.pl/images/zf-share.jpg" />) :
                            (<meta property="og:image" content={window.location.origin + this.state.ProfileImgUrl} />)
                    }
                    {
                        !IsNullEmptyOrUndefined(this.state.FirstName) && !IsNullEmptyOrUndefined(this.state.LastName) ?
                            (<meta property="og:title" content={this.state.FirstName + ' ' + this.state.LastName + ' - Znajdź fizjoterapeutę'} />) :
                            (<meta property="og:title" content="Znajdź fizjoterapeutę" />)
                    }
                </Helmet>
                {this.RenderMapModal()}
                <ShareButtonsComponent
                    Visible={this.state.ShareVisible}
                    OnCloseClick={this.HideShareModal}
                    UrlValue={
                        window.location.origin + this.GenerateUrl()
                        /*window.location.origin + '/fizjoterapeuta/' + this.state.PhysiotherapistId*/
                    } />
                <div className="physiotherapist-view-component view-component route-component">
                    <div>
                        <div className="quick-search">
                            {this.RenderBasicSearchCriteriaComponent()}
                        </div>
                        <div className="main-container-outer">
                            <div className="main-container">
                                <div className="left-panel">
                                    {this.RenderBreadcrumbs()}
                                    <div className="header-section section">
                                        <div className="profile-picture-section">
                                            {this.RenderProfileImage()}
                                            {this.RenderUploadProfileImgComponent()}
                                        </div>
                                        <div className="basic-info">
                                            <h1 className="name-and-surname">
                                                {
                                                    (this.state.ProfessionalTitleShort ? this.state.ProfessionalTitleShort + ' ' : '')
                                                    + (this.state.FirstName ? this.state.FirstName : '')
                                                    + ' '
                                                    + (this.state.LastName ? this.state.LastName : '')
                                                }
                                            </h1>
                                            <span className="professional-title">
                                                <b>{(this.state.ProfessionalTitle ? this.state.ProfessionalTitle : '')}</b>
                                            </span>
                                            <span className="profession-number">
                                                <b>Numer prawa wykonywania zawodu (PWZFz):</b> {(this.state.ProfessionNumber ? this.state.ProfessionNumber : '')}
                                            </span>
                                        </div>
                                        <div className="buttons-section">
                                            <div className="share-btn">
                                                <button className="std-secondary-btn-alt" onClick={this.ShowShareModal}>Udostępnij</button>
                                            </div>
                                            {this.RenderAddToFavoriteBtn()}
                                        </div>
                                    </div>
                                    <div className="visit-section-container">
                                        {this.RenderArrangeVisitComponent()}
                                    </div>
                                    <TabsComponent
                                        SelectedTab={this.state.SelectedTab}
                                        AddressesCount={this.state.ClinicsNumber}
                                        OnTabSelected={this.OnTabSelected} />
                                    {this.RenderClinicSectionComponent()}
                                    <PhysiotherapistInfoComponent
                                        PhysiotherapistId={this.state.PhysiotherapistId}
                                        ShowExperienceSection={this.state.SelectedTab === 'Addresses' || this.state.SelectedTab === 'Experience'}
                                        ShowSpecializationSection={this.state.SelectedTab === 'Addresses' || this.state.SelectedTab === 'Specializations'}
                                    />
                                </div>
                                <div className="right-panel">
                                    {this.RenderArrangeVisitComponent()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <FooterComponent OnItemClick={this.OnFooterItemClick} />
                    <FooterStaticComponent />
                </div>
            </>
        );
    }//end-of-render

    private RenderAddToFavoriteBtn() {
        if (this.props.ProfileInfo.Role !== 'Physiotherapist') {
            return (
                <div className="add-to-favorite-btn">
                    {
                        this.state.IsFavorite === true ?
                            (<button className="std-primary-btn" onClick={this.RemoveFavorite}>
                                <div className="std-btn-multiline">
                                    <span>Dodano do&nbsp;</span>ulubionych
                            </div>
                            </button>) :
                            (<button className="std-secondary-btn" onClick={this.AddToFavorite}>
                                <div className="std-btn-multiline">
                                    <span>Dodaj do&nbsp;</span>ulubionych
                            </div>
                            </button>)
                    }
                </div>
            );
        } else {
            return null;
        }
    }

    private RenderMapModal() {
        if (this.state.MapVisible && this.state.Place !== undefined) {
            return (
                <MapModalComponent
                    ResultItems={this.state.ResultItems}
                    Place={this.state.Place}
                    OnViewPortChanged={this.OnViewPortChanged}
                    OnAbort={this.CloseMapModal}
                />
            );
        } else {
            return null;
        }
    }

    private RenderBasicSearchCriteriaComponent() {
        if (this.state.PhysiotherapistId) {
            return (<BasicSearchCriteriaComponent ref={this.basicSearchRef} />);
        } else {
            return null;
        }
    }

    private RenderArrangeVisitComponent() {
        if (this.state.PhysiotherapistId) {
            return (
                <ArrangeVisitComponent
                    PhysiotherapistId={this.state.PhysiotherapistId}
                    Clinics={this.state.Clinics}
                    OnClinicSelected={this.OnClinicSelected}
                    SelectedClinic={this.state.SelectedClinic}
                    ShowClinicOnMap={this.state.PhysiotherapistId ? this.ShowClinicOnMap : undefined} />
            );
        } else {
            return null;
        }
    }

    private RenderProfileImage() {
        if (this.state.ProfileImgUrl === null) {
            return (
                <div className="profile-picture">
                    <img src={'/images/default_profile_pic.svg'} />
                </div>
            );
        } else {
            return (
                <div className="profile-picture">
                    <img src={this.state.ProfileImgUrl} />
                </div>
            );
        }
    }

    private RenderUploadProfileImgComponent() {
        if (this.state.PhysiotherapistId === undefined) {
            if (this.state.ShowUploadProfileImgComponent) {
                return (
                    <div className="img-upload">
                        <FileUploadComponent
                            MaxFileCount={1}
                            UploadUrl="api/physiotherapist/myprofileimg"
                            FileTypes="image/jpeg, image/png"
                            OnFileUploaded={this.OnProfileImgUploaded} />
                    </div>
                );
            } else {
                if (this.state.ProfileImgUrl === null) {
                    return (
                        <div className="img-upload">
                            <a onClick={this.OnSetProfileImgClick}>Ustaw zdjęcie profilowe</a>
                        </div>
                    );
                } else {
                    return (
                        <div className="img-upload">
                            <a onClick={this.OnDeleteProfileImgClick}>Usuń zdjęcie profilowe</a>
                        </div>
                    );
                }
            }
        } else {
            return null;
        }
    }

    private RenderBreadcrumbs() {
        if (this.state.PhysiotherapistId) {
            let breadcrumbs: IBreadcrumbItem[] = [];
            breadcrumbs.push({ ViewName: 'Strona główna', Path: '/' });
            if (this.props.SearchCriteriaPlaceInputValue) {
                breadcrumbs.push({
                    ViewName: this.props.SearchCriteriaPlaceInputValue.name,
                    Path: '/szukaj/' + SimplifyString(this.props.SearchCriteriaPlaceInputValue.name)
                });
            }
            if (this.state.FirstName) {
                breadcrumbs.push({ ViewName: this.state.FirstName + ' ' + this.state.LastName, Path: this.props.match.url });
            }
            return (
                <div className="breadcrums">
                    <BreadcrumbsComponent BreadcrumbItems={breadcrumbs} />
                </div>
            );
        } else {
            return null;
        }
    }

    private RenderClinicSectionComponent() {
        if (this.state.SelectedTab === 'Addresses') {
            return (
                <ClinicSectionComponent
                    PhysiotherapistId={this.state.PhysiotherapistId}
                    Clinics={this.state.Clinics}
                    OnRefreshRequired={this.RefreshClinicsListData}
                    ShowClinicOnMap={this.state.PhysiotherapistId ? this.ShowClinicOnMap : undefined} />
            );
        } else {
            return null;
        }
    }

    private RefreshBasicInfo(physiotherapistId?: string) {
        let physiotherapistService = new PhysiotherapistService();
        if (physiotherapistId) {
            physiotherapistService.GetPhysiotherapist(physiotherapistId, this.OnGetDataSuccess, this.OnGetDataError);
        } else {
            if (this.state.PhysiotherapistId) {
                physiotherapistService.GetPhysiotherapist(this.state.PhysiotherapistId, this.OnGetDataSuccess, this.OnGetDataError);
            } else {
                physiotherapistService.GetCurrentPhysiotherapist(this.OnGetDataSuccess, this.OnGetDataError);
            }
        }
    }

    private OnGetDataSuccess(result) {
        this.setState({
            Email: result.data.Value.Email,
            ContactEmail: result.data.Value.ContactEmail,
            FirstName: result.data.Value.FirstName,
            LastName: result.data.Value.LastName,
            ProfessionalTitle: result.data.Value.ProfessionalTitle,
            ProfessionalTitleShort: result.data.Value.ProfessionalTitleShort,
            ProfessionNumber: result.data.Value.ProfessionNumber,
            ProfileImgUrl: result.data.Value.ProfileImgUrl,
            AboutMe: result.data.Value.AboutMe,
            Specialization: result.data.Value.Specialization,
            IsFavorite: result.data.Value.IsFavorite
        }, this.UpdateUrl);
    }

    private OnGetDataError(error) {
        console.error(error);
    }

    private OnSetProfileImgClick(evt) {
        this.setState({
            ShowUploadProfileImgComponent: true
        });
    }

    private OnProfileImgUploaded() {
        this.setState({
            ShowUploadProfileImgComponent: false
        });
        let physiotherapistService = new PhysiotherapistService();
        physiotherapistService.GetCurrentPhysiotherapist(this.OnGetDataSuccess, this.OnGetDataError);
    }

    private OnDeleteProfileImgClick(evt) {
        let service = new PhysiotherapistService();
        service.DeleteProfileImage(this.OnDeleteProfileImgSuccess, this.OnDeleteProfileImgError);
    }

    private OnDeleteProfileImgSuccess(result) {
        let physiotherapistService = new PhysiotherapistService();
        physiotherapistService.GetCurrentPhysiotherapist(this.OnGetDataSuccess, this.OnGetDataError);
    }

    private OnDeleteProfileImgError(error) {
        console.error(error);
    }

    private OnTabSelected(selectedTab: 'Addresses' | 'Experience' | 'Specializations') {
        this.setState({
            SelectedTab: selectedTab
        });
    }

    private RefreshClinicsListData(physiotherapistId?: string) {
        let service = new ClinicService();
        if (physiotherapistId) {
            service.GetPhysiotherapistsClinics(physiotherapistId, this.OnGetClinicListItemsSuccess, this.OnGetClinicListItemsError);
        } else {
            if (this.state.PhysiotherapistId) {
                service.GetPhysiotherapistsClinics(this.state.PhysiotherapistId, this.OnGetClinicListItemsSuccess, this.OnGetClinicListItemsError);
            } else {
                service.GetMyClinicsList(this.OnGetClinicListItemsSuccess, this.OnGetClinicListItemsError);
            }
        }
    }

    private OnGetClinicListItemsSuccess(result): void {
        let selectedClinic: IClinicListItem | undefined;
        let urlParamsList = this.GetUrlParamsList(this.props);
        if (urlParamsList.length > 1) {
            for (let clinic of result.data.Value as IClinicListItem[]) {
                if (SimplifyString(clinic.FullName).indexOf(urlParamsList[urlParamsList.length - 2]) !== -1) {
                    selectedClinic = clinic;
                    break;
                }
            }
        }
        if (result.data.Value.length > 0 && selectedClinic === undefined) {
            selectedClinic = result.data.Value[0];
        }

        this.setState({
            SelectedClinic: selectedClinic,
            Clinics: result.data.Value,
            ClinicsNumber: result.data.Value.length as number
        }, this.UpdateUrl);

        if (this.props.PhysiotherapistId) {
            if (this.props.ProfileInfo.Role === 'Physiotherapist' && result.data.Value.length === 0) {
                ShowStatusBar('Info', 'Twoja lista adresów jest pusta. Uzupełnij swoje miejsce pracy.', DEFAULT_STATUS_TIMEOUT * 3);
            }
        }
    }

    private OnGetClinicListItemsError(error): void {
        console.error(error);
    }

    private AddToFavorite(evt) {
        if (this.state.PhysiotherapistId) {
            let service = new FavoriteService();
            service.AddToFavorite(this.state.PhysiotherapistId, this.OnAddToFavoriteSuccess, this.OnAddToFavoriteError);
        }
    }

    private OnAddToFavoriteSuccess(result) {
        if (result.request.responseURL.indexOf('Account/Login') !== -1) {
            ShowStatusBar('Info', 'Zaloguj się aby dodać do ulubionych', DEFAULT_STATUS_TIMEOUT);
        } else {
            ShowStatusBar('Success', 'Dodano do ulubionych', DEFAULT_STATUS_TIMEOUT);
        }
        this.RefreshBasicInfo();
    }

    private OnAddToFavoriteError(error) {
        console.error(error);
        if (error.response.status === 401) {
            ShowStatusBar('Info', 'Zaloguj się aby dodać do ulubionych', DEFAULT_STATUS_TIMEOUT);
        } else {
            ShowStatusBar('Error', 'Nie udało się dodać do ulubionych', DEFAULT_STATUS_TIMEOUT);
        }
    }

    private RemoveFavorite() {
        if (this.state.PhysiotherapistId) {
            let service = new FavoriteService();
            service.RemoveFavorite(
                this.state.PhysiotherapistId,
                this.OnRemoveFavoriteSuccess,
                this.OnRemoveFavoriteError);
        }
    }

    private OnRemoveFavoriteSuccess(result) {
        ShowStatusBar('Success', 'Usunięto z ulubionych', DEFAULT_STATUS_TIMEOUT);
        this.RefreshBasicInfo();
    }

    private OnRemoveFavoriteError(error) {
        console.error(error);
        ShowStatusBar('Error', 'Nie udało się usunąć z ulubionych', DEFAULT_STATUS_TIMEOUT);
    }

    private OnViewPortChanged(viewport: IViewport) {
        //null
    }

    private CloseMapModal() {
        this.setState({
            MapVisible: false
        });
    }

    private ShowClinicOnMap(clinic: IClinicListItem) {
        if (clinic.Lat !== undefined &&
            clinic.Lng !== undefined &&
            clinic.Lat !== 0 &&
            clinic.Lng !== 0 &&
            this.state.PhysiotherapistId !== undefined
        ) {
            this.setState({
                MapVisible: true,
                Place: {
                    location: {
                        lat: clinic.Lat,
                        lng: clinic.Lng
                    },
                    id: '',
                    name: '',
                    administrativeArea: '',
                    useOnlyViewportForSearch: false
                },
                ResultItems: [{
                    LocationData: [{
                        id: 0,
                        lat: clinic.Lat,
                        lng: clinic.Lng
                    }],
                    BasicInfo: {
                        FirstName: this.state.FirstName ? this.state.FirstName : '',
                        Id: this.state.PhysiotherapistId,
                        IsFavorite: false,
                        LastName: this.state.LastName ? this.state.LastName : '',
                        ProfessionNumber: '',
                        ProfileImgUrl: this.state.ProfileImgUrl,
                        Specialization: '',
                        HasTele: false,
                        HasHomeService: false
                    },
                    Clinics: [{
                        Id: 0,
                        FullAddress: clinic.FullAddress,
                        FullName: clinic.FullName,
                        IsHomeService: clinic.IsHomeService,
                        HomeServiceScope: clinic.HomeServiceScope
                    }],
                    PriceList: [],
                    TimeTableDays: [],
                    TimeTable: {
                        HasAnyWorkHours: false,
                        PhysiotherapistId: '',
                        TimeTableDay: []
                    }

                }]
            });
        }
    }

    private OnFooterItemClick(item: ISearchSelectedItem) {
        window.scrollTo(0, 0);
        if (this.basicSearchRef.current !== null) {
            this.basicSearchRef.current.Search(item);
        }
    }

    private ShowShareModal(evt) {
        this.setState({
            ShareVisible: true
        });
    }

    private HideShareModal() {
        this.setState({
            ShareVisible: false
        });
    }

    private GetUrlParamsList(props: RouteComponentProps<any>): string[] {
        let urlParamsList: string[] = [];
        if (props.match.params.id_1) {
            urlParamsList.push(props.match.params.id_1);
            if (props.match.params.id_2) {
                urlParamsList.push(props.match.params.id_2);
                if (props.match.params.id_3) {
                    urlParamsList.push(props.match.params.id_3);
                    if (props.match.params.id_4) {
                        urlParamsList.push(props.match.params.id_4);
                        if (props.match.params.id_5) {
                            urlParamsList.push(props.match.params.id_5);
                        }
                    }
                }
            }
        }
        return urlParamsList;
    }

    private UpdateUrl() {
        if (!IsNullEmptyOrUndefined(this.props.PhysiotherapistId)) {
            return;
        }
        if (this.state.FirstName === undefined || this.state.LastName === undefined || this.state.SelectedClinic === undefined) {
            return;
        }
        let newUrl = this.GenerateUrl();

        this.props.history.push(newUrl);
    }

    private GenerateUrl(): string {
        let selectedClinic = this.state.SelectedClinic ? this.state.SelectedClinic : (this.state.Clinics.length > 0 ? this.state.Clinics[0] : undefined);
        let newUrl = '/fizjoterapeuta'
            + '/' + SimplifyString(this.state.FirstName + '-' + this.state.LastName)
            + (selectedClinic ?
                (IsNullEmptyOrUndefined(selectedClinic.Voivodeship) ? '' : ('/' + SimplifyString(selectedClinic.Voivodeship))) :
                '')
            + (selectedClinic ?
                (IsNullEmptyOrUndefined(selectedClinic.City) ? '' : ('/' + SimplifyString(selectedClinic.City))) :
                '')
            + (selectedClinic ?
                (IsNullEmptyOrUndefined(selectedClinic.FullName) ? '' : ('/' + SimplifyString(selectedClinic.FullName))) :
                '')
            + '/' + this.state.PhysiotherapistId
            ;
        return newUrl;
    }

    private OnClinicSelected(newClinic: IClinicListItem) {
        this.setState({
            SelectedClinic: newClinic
        }, this.UpdateUrl);
    }
}

export default connect(MapState)(PhysiotherapistViewComponent);


// WEBPACK FOOTER //
// ./src/components/PhysiotherapistView/PhysiotherapistView.tsx